import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Term} from "../../../../classes/term";
import {kanTermsService} from "../../../services/services/terms";

@Component({
    selector: 'kan-term-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanTermDialog {
    public term: Term = new Term();
    public isNew: boolean = true;

    public termForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanTermDialog>,
                private formBuilder: FormBuilder,
                private termsService: kanTermsService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.term) {
            this.term = JSON.parse(JSON.stringify(this.data.term));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.termForm = this.formBuilder.group({
            name: new FormControl(this.term.name, [Validators.required]),
            body: new FormControl(this.term.body, [Validators.required])
        });
    }

    public addTerm(event: any) {

        this.termsService.addTerm(this.term)
            .then((note) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateTerm(event: any) {

        this.termsService.updateTerm(this.term)
            .then((note) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/term-dialog/component.ts